var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasModule.competitions)?_c('ActiveCompetitions',{staticClass:"u-marginBottom3 u-marginBottom7@tabletPortrait"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }